import scrollService from '../services.common/scrollService';
import resizeService from '../services.common/resizeService';

const SITE_HEADER_NAME = 'site-header';

export default class SiteHeader extends HTMLElement {
    connectedCallback() {
        this._handleClickEvent = this._handleClickEvent.bind(this);
        this._handleResizeEvent = this._handleResizeEvent.bind(this);

        this.ACTIVE_CLASS = `${SITE_HEADER_NAME}--active`;
        this.FIXED_WINDOW_CLASS = `fixed-window`;

        this._toggle = this.querySelector(`[${SITE_HEADER_NAME}-toggle]`);
        this._nav = this.querySelector(`[${SITE_HEADER_NAME}-nav]`);

        if (this._toggle == null) {
            console.warn(`The '${SITE_HEADER_NAME}-toggle' element must be nested inside a 'site-header' element.`);
            return;
        }

        this._toggle.addEventListener('click', this._handleClickEvent);

        resizeService.add(this._handleResizeEvent);
    }

    get menuIsOpen() {
        return this.classList.contains(this.ACTIVE_CLASS);
    }

    _handleClickEvent() {
        this._toggleHeader(!this.menuIsOpen);
    }

    _handleResizeEvent() {
        if (this.menuIsOpen && !resizeService.isMd()) {
            this._nav.style.height = `${window.innerHeight}px`;
        } else if (resizeService.isMd()) {
            this._nav.style.height = ``;
        }

        if (this.menuIsOpen && resizeService.isLg()) {
            this._toggleHeader(false);
        }
    }

    _toggleHeader(open) {
        if (open === true) {
            if (resizeService.isMd() === false) {
                this._nav.style.height = `${window.innerHeight}px`;
            }

            scrollService.disableBodyScroll(this);
            this.classList.add(this.ACTIVE_CLASS);
        } else {
            scrollService.enableBodyScroll(this);
            this.classList.remove(this.ACTIVE_CLASS);
        }
    }
}

customElements.define(SITE_HEADER_NAME, SiteHeader, { extends: 'header' });
